import React, { FC } from 'react';


type Props = {
    fillOnSp?: boolean;
};


export const Section: FC<Props> = ({ fillOnSp = false, children }) => {
    return (
        <section className={fillOnSp ? '-fill' : ''}>
            {children}

            <style jsx>{`
                section {
                    flex: 1;
                    margin-left: 18%;
                    margin-right: 18%;
                    margin-bottom: 24px;
                    margin-top: 24px;
                    padding-left: 40px;
                    padding-right: 40px;
                    padding-bottom: 80px;
                    background: #fff;
                }
                section.-fill {
                    padding-top: 40px;
                }
                @media screen and (max-width: 540px) {
                    section {
                        padding-left: 32px;
                        padding-right: 32px;
                        padding-bottom: 24px;
                        margin: 0;
                        margin-top: 12px;
                    }
                    section.-fill {
                        margin: 0;
                        padding: 0;
                    }
                }
            `}</style>
        </section>
    );
};
